import modalCoachmarkComponent from './modalCoachmark.component';

let modalCoachmarkModule = angular.module('vacations-absences.modalCoachmark', [])

.component('modalCoachmark', modalCoachmarkComponent)

.name;

export default modalCoachmarkModule;



// WEBPACK FOOTER //
// ./client/app/components/modalCoachmark/modalCoachmark.js